import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

const Careers = () => {
  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => { if (entry.isIntersecting) entry.target.classList.add('visible'); });
    }, { threshold: 0.1 });
    document.querySelectorAll('.scroll-reveal, .job-card, .benefit-card').forEach(el => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  const jobs = [
    { title: "Data Analyst", company: "AALITECH", location: "Guntur, India", type: "Full-time" },
    { title: "Associate Software Engineer (Trainee)", company: "AALITECH", location: "Guntur, India", type: "Trainee" },
    { title: "Data Operator", company: "AALI GROUP", location: "Guntur, India", type: "Full-time" },
    { title: "Chat Process Executive", company: "AALI CONSSULTANCY", location: "Guntur, India", type: "Full-time" },
    { title: "Consultancy Calling Associate", company: "AALI CONSSULTANCY", location: "Guntur, India", type: "Full-time" },
    { title: "Data Typing Specialist", company: "AALI GROUP", location: "Guntur, India", type: "Full-time" }
  ];

  const benefits = [
    { title: "Growth Opportunities", desc: "Continuous learning and career advancement across diverse industries", icon: "📈" },
    { title: "Collaborative Culture", desc: "Work with talented professionals in a supportive environment", icon: "🤝" },
    { title: "Work-Life Balance", desc: "Flexible policies that respect your personal life", icon: "⚖️" },
    { title: "Competitive Benefits", desc: "Comprehensive compensation and benefits package", icon: "🎁" }
  ];

  return (
    <>
      <div className="careers-hero">
        <div className="container">
          <h1>Careers at AALI GROUP</h1>
          <p>Join our talented team and be part of building excellence across industries – based in Guntur, shaping global futures.</p>
        </div>
      </div>

      <section className="life-section">
        <div className="container">
          <h2>Life at AALI GROUP</h2>
          <p className="subtitle">A place where talent meets opportunity and innovation drives success</p>
          <div className="benefits-grid">
            {benefits.map((b, idx) => (
              <div key={idx} className="benefit-card scroll-reveal">
                <div className="benefit-icon"><span style={{ fontSize: '2rem' }}>{b.icon}</span></div>
                <h3>{b.title}</h3>
                <p>{b.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="openings-section">
        <div className="container">
          <h2>Current Openings – Guntur</h2>
          <p className="subtitle">Explore opportunities across our diverse portfolio of companies</p>
          <div className="jobs-list">
            {jobs.map((job, idx) => (
              <div key={idx} className="job-card scroll-reveal">
                <div className="job-info">
                  <h3>{job.title}</h3>
                  <div className="job-meta">
                    <span className="company"><i className="fas fa-building"></i> {job.company}</span>
                    <span><i className="fas fa-map-marker-alt"></i> {job.location}</span>
                    <span><i className="fas fa-clock"></i> {job.type}</span>
                  </div>
                </div>
                <Link to="/contact" className="apply-btn">Apply Now →</Link>
              </div>
            ))}
          </div>
        </div>
      </section>

      <div className="internship-section">
        <div className="container">
          <h2>Internship Program</h2>
          <p>Kickstart your career with hands‑on experience across our diverse business portfolio</p>
          <Link to="/contact" className="cta-btn">Learn More →</Link>
        </div>
      </div>

      <div className="resume-section">
        <div className="container">
          <h2>Don't See a Perfect Fit?</h2>
          <p>We're always looking for talented individuals. Send us your resume and we'll keep you in mind for future opportunities.</p>
          <Link to="/contact" className="submit-btn">Email Your Resume</Link>
        </div>
      </div>
    </>
  );
};

export default Careers;